import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//images
import galleryIcon from '/assets/images/galleryIcon.png';
import fileIcon from '/assets/images/fileIcon.png';
import scanlineIcon from '/assets/images/scanlineIcon.png';
import unreportedBillIcon from '/assets/images/unreportedBillIcon.png';
import addBillIcon from '/assets/images/addBillIcon.png';
const FileAttachedModal = ({ isOpen, onClose, showModal, type }) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedImages(files);
  };

  const handleNavigate = (path) => {
    navigate(path, { state: true }); // Pass true as state
    onClose();
  };

  const dividerClass = 'divider-y h-[0.5px] w-full bg-line-color';

  return (
    <>
      {showModal && (
        <>
          <div className="absolute bottom-0 top-16 right-10 z-50">
            <div className="">
              {/*content*/}
              <div className="bg-[#F5F5F5] h-[5rem] w-60 border-[0.5px] border-line-color rounded-xl shadow-top1 relative flex flex-col outline-none focus:outline-none  text-center pt-2  ">
                {/*header*/}
                <div className="flex ml-3 justify-between p-2 border-b border-solid rounded-t" onClick={() => handleNavigate('/un-reported-expenses')}
                >
                  <button
                    className="flex gap-3 items-center"
                  >
                    <img src={unreportedBillIcon} alt="unreportedBillIcon"  height={'12px'} width={'12px'}/>
                    <p className="text-baseSm font-medium text-[#514D4C]">Unreported Bills</p>
                  </button>
                </div>
                <div className={dividerClass}></div>
                {/*
                <div className="flex ml-3 justify-between p-2 border-b border-solid rounded-t">
                  <button
                    onClick={() => handleNavigate('/camera')}
                    className="flex gap-3 items-center"
                  >
                    <img src={scanlineIcon} alt="scanlineIcon" height={'12px'} width={'12px'}/>
                    <p className="text-baseSm font-medium text-[#514D4C]">Invoice Scan</p>{' '}
                  </button>
                </div>
                <div className={dividerClass}></div>
                <div className="flex ml-3 justify-between p-2 border-b border-solid rounded-t">
                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: 'none' }}
                    accept="image/*"
                    multiple
                    onChange={handleFileChange}
                  />
                  <button
                    onClick={() => document.getElementById('fileInput').click()}
                    className="flex gap-3 items-center"
                  >
                    <img src={galleryIcon} alt="fileIcon" height={'12px'} width={'12px'}/>
                    <p className="text-baseSm font-medium text-[#514D4C]">Photo</p>
                  </button>
                </div>
                <div className={dividerClass}></div>

                <div className="flex ml-3 justify-between p-2 border-b border-solid rounded-t">
                  <input
                    type="file"
                    id="fileInput1"
                    accept=".pdf"
                    style={{ display: 'none' }}
                    multiple
                    onChange={handleFileChange}
                  />
                  <button
                    onClick={() =>
                      document.getElementById('fileInput1').click()
                    }
                    className="flex gap-3 items-center"
                  >
                    <img src={fileIcon} alt="fileIcon" height={'12px'} width={'12px'}/>
                    <p className="text-baseSm font-medium text-[#514D4C]">Gallery</p>
                  </button>
                </div> */}
                 <>
                 <div
                    className="lg:hidden flex  justify-between  border-b border-solid rounded-t"

                    onClick={() =>navigate('/camera')}
                  >
                    <button className="flex ml-3 gap-3 items-cente p-2 pb-2">
                      <img
                        src={addBillIcon}
                        alt="bill icon"
                        height={'12px'}
                        width={'12px'}
                      />
                      <p className="text-baseSm font-medium text-[#514D4C]">
                        Add bill
                      </p>
                    </button>
                  </div>

                  <div
                    className="smAndMd:hidden flex  justify-between  border-b border-solid rounded-t"

                    onClick={() =>navigate('/upload-bills')}
                  >
                    <button className="flex ml-3 gap-3 items-cente p-2 pb-2">
                      <img
                        src={addBillIcon}
                        alt="bill icon"
                        height={'12px'}
                        width={'12px'}
                      />
                      <p className="text-baseSm font-medium text-[#514D4C]">
                        Add bill
                      </p>
                    </button>
                  </div>
                 </>

              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 "></div>
        </>
      )}
    </>
  );
};

export default FileAttachedModal;
